import { makeReducer } from '../utils/redux.tools';
import { SettingsActions } from '../actions/settings.actions';

const initialState = {};

const settingsRed = {
    /*~~~~ FETCH_VIEWER_TYPE_RETURN ~~~~*/
    [SettingsActions.FETCH_VIEWER_TYPE_RETURN]: (state, payload) => ({
        ...state,
        viewerType: payload
    })
};

export const settingsReducer = makeReducer('Settings', initialState, settingsRed);
